import CountUp from 'react-countup';
import * as Styled from './Score.styled';

export const Score = ({
  title,
  value,
  type,
  dataTableViewEnabled
}: {
  readonly title: string;
  readonly value: number;
  readonly type: number;
  readonly dataTableViewEnabled: boolean;
}) => (
  <Styled.Score tabIndex={0} role="status" aria-label={`${value} ${title}`} $fixedWidth={dataTableViewEnabled}>
    <div className="title">{title}</div>
    <div className="value" data-testid={`score-${type}`} data-value={value}>
      <CountUp end={value} duration={1} />
    </div>
  </Styled.Score>
);
